/*
 * vrtPSHTF.ts - HCT (Head Chief Trainer) Version
 */
import type { RouteRecordRaw } from 'vue-router';
//
const vrtPSHTFV2: RouteRecordRaw = {
  path: '/powersteer/HTFV2',
  name: 'vrtPSHTFV2',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    // HCT TRAINER WEEKEND DUTY
    {
      path: 'trainer/weekend/duty/list',
      name: 'vrtPSHTFV2TrainerWeekendDutyList',
      component: () => import('./vpgPSHTFTrainerWeekendDutyListV2.vue'),
    },
    {
      path: 'trainer/weekend/duty/mylist',
      name: 'vrtPSHTFV2TrainerMyWeekendDutyList',
      component: () => import('./vpgPSHTFTrainerMyWeekendDutyListV2.vue'),
    },
    {
      path: 'trainer/weekend/duty/location/preference',
      name: 'vrtPSHTFV2TrainerLocationPreference',
      component: () => import('./vpgPSHTFTrainerLocationPreferenceV2.vue'),
    },
    {
      path: 'trainer/ehelp/operate',
      name: 'vrtPSHTFeHelpOperate',
      component: () => import('./vpgPSHTFeHELPOperate.vue'),
    },
    {
      path: 'report/fifthdetail',
      name: 'vrtPSHTF5thDetailReport',
      component: () => import('./vpgPSHTF5thDetailReport.vue'),
    },
  ],
};
//
export default vrtPSHTFV2;
//#end#
